export const APP_NAME = 'BuildPro';
export const APP_SUBTITLE = 'Gestión de Obras y Presupuestos';
export const APP_COLOR = '#f59e0b';
export const APP_ICON_PATH = '/brand/icon.svg';
export const APP_WORDMARK_PATH = '/brand/wordmark.png';
